import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";

interface Props {
  metric: SalesMetricV2;
}

export const MetricDetailsPanel = ({ metric }: Props) => {
  return (
    <div className="flex flex-col space-y-1">
      <div className="text-sm text-gray+1 font-light pt-2">Metric Category</div>
      TODO
      {/* <p>{tooltip.reported} reported</p> */}
      <div className="text-sm text-gray+1 font-light pt-2">What is it?</div>
      TODO
      {/* <p dangerouslySetInnerHTML={{ __html: tooltip.description }}></p> */}
      {/* {tooltip.calculationInfo && (
        <>
          <div className="text-sm text-gray+1 font-light pt-2">
            How it&apos;s calculated
          </div>
          <p dangerouslySetInnerHTML={{ __html: tooltip.calculationInfo }}></p>
        </>
      )} */}
      {/* {tooltip.showAttributionWindowInfo && (
        <>
          <div className="text-sm text-gray+1 font-light pt-2">
            Attribution window
          </div>
          <p>
            {isLtv ? (
              "Reported transactions based on the lifetime of touchpoints."
            ) : (
              <>
                Reported transactions took place within{" "}
                <GenericTooltip
                  noInfoCircle
                  content={`Attribution window is set to "${attributionWindow} day"`}
                >
                  <span className="text-primary">
                    [{attributionWindow} day]
                  </span>
                </GenericTooltip>{" "}
                of the touchpoint.
              </>
            )}
          </p>
        </>
      )} */}
    </div>
  );
};
